import { render, staticRenderFns } from "./view.vue?vue&type=template&id=6baa1edc&scoped=true&"
import script from "./view.vue?vue&type=script&lang=js&"
export * from "./view.vue?vue&type=script&lang=js&"
import style0 from "./view.vue?vue&type=style&index=0&id=6baa1edc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6baa1edc",
  null
  
)

export default component.exports